export const LogLevel = {
  DEFAULT: 0,
  DEBUG: 1,
  INFO: 2,
  WARN: 3,
  ERROR: 4,
  FAIL: 5,
} as const
